import { render } from "./FoodComboSlider.vue?vue&type=template&id=4e1c9109"
import script from "./FoodComboSlider.vue?vue&type=script&lang=js"
export * from "./FoodComboSlider.vue?vue&type=script&lang=js"

import "./FoodComboSlider.vue?vue&type=style&index=0&id=4e1c9109&lang=scss"
import "./FoodComboSlider.vue?vue&type=style&index=1&id=4e1c9109&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__